<!--
  Monitor de señales en revisión (reporte r113).

  Vigila las máquinas cuya señal de conteo está en duda y dice cuál está
  fallando ahora mismo. Este componente no calcula nada: el análisis vive en
  MonitorSenalesService (backend) y aquí solo se pinta lo que devuelve
  /api/MonitorSenales/Estado. Cada instancia muestra su propia planta.
-->
<template>
  <v-col cols="12" class="pa-0">
    <div id="monitor-senales" @click="clic">
      <div class="ms-head">
        <div>
          <h1>Monitor de señales en revisión</h1>
          <div class="sub">{{ sub }}</div>
        </div>
        <div class="der">
          <span>{{ reloj }}</span>
          <button class="claro" @click.stop="refrescar">Actualizar ahora</button>
        </div>
      </div>
      <main>
        <div ref="error"></div>
        <div ref="foco"></div>
        <div class="cards" ref="cards"></div>
        <div ref="detalle"></div>
        <div class="tabla"><table>
          <thead><tr ref="cab"></tr></thead><tbody ref="cuerpo"></tbody></table></div>
        <div class="barra">
          <strong style="font-size:13px">Agregar máquina:</strong>
          <select v-model="nueva">
            <option value="">— elegir —</option>
            <option v-for="m in disponibles" :key="m" :value="m">{{ m }}</option>
          </select>
          <input v-model="moldes" placeholder="molde(s) en revisión — opcional" size="26">
          <input v-model="motivo" placeholder="motivo — opcional" size="24">
          <button :disabled="agregando" @click.stop="agregar">
            {{ agregando ? 'cargando historia de ' + nueva + '…' : 'Agregar' }}
          </button>
          <span class="mini" style="margin-left:auto">Para quitar una máquina usa la × de su renglón; su historia se conserva.</span>
        </div>
        <div class="barra" style="display:block" ref="cajaSesiones"></div>
        <div class="barra" style="display:block" ref="cajaAvisos"></div>
        <div class="nota" ref="nota"></div>
      </main>
    </div>
  </v-col>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "ReporteMonitorSenales",
  props: {
    active: { type: Boolean, default: true },
  },
  data() {
    return {
      sub: "cargando…",
      reloj: "",
      nueva: "",
      moldes: "",
      motivo: "",
      agregando: false,
      disponibles: [],
    };
  },
  mounted() {
    // El estado del tablero (D, listas de los paneles) se guarda fuera de
    // data(): es un objeto grande que se repinta a mano, no necesita
    // reactividad y hacerlo reactivo lo volvería lento.
    this.D = null;
    this.ultimo = 0;
    this.abierta = null;
    this.tTic = setInterval(this.tic, 1000);
    this.tCarga = setInterval(() => { if (this.active) this.cargar(); }, 20000);
    this.cargar();
  },
  beforeDestroy() {
    clearInterval(this.tTic);
    clearInterval(this.tCarga);
  },
  computed: {
    ...mapState({ nombreEmpresa: "nombreEmpresa" }),
  },
  watch: {
    active(v) { if (v) this.cargar(); },
  },
  methods: {
    f(n) { return n == null ? "—" : n.toLocaleString("es-MX"); },
    async cargar() {
      try {
        const r = await axios.get("/MonitorSenales/Estado");
        this.D = r.data;
        this.pinta();
      } catch (e) {
        const msj = (e.response && e.response.data && e.response.data.error) || e;
        this.$refs.error.innerHTML =
          '<div class="err">No se pudo leer el estado del monitor: ' + msj + "</div>";
      }
    },
    async refrescar() {
      this.reloj = "consultando…";
      try { await axios.post("/MonitorSenales/Refrescar", {}); } catch (e) { /* cargar reporta */ }
      await this.cargar();
    },
    async agregar() {
      if (!this.nueva) { alert("Elige primero una máquina de la lista."); return; }
      this.agregando = true;
      try {
        await axios.post("/MonitorSenales/Agregar",
          { maquina: this.nueva, moldes: this.moldes, motivo: this.motivo });
        this.moldes = ""; this.motivo = "";
      } finally { this.agregando = false; }
      await this.cargar();
    },
    async quitaMolde(m, mo) {
      if (!confirm("¿Liberar la combinación " + m + " con el molde " + mo + "?\n\n" +
          "Si a la máquina le quedan otros moldes en revisión, sigue vigilada. " +
          "Si era el último, la máquina sale de la lista.\n\nLa historia se conserva.")) return;
      const r = await axios.post("/MonitorSenales/QuitarMolde", { maquina: m, molde: mo });
      await this.cargar();
      if (r.data.maquina_fuera) alert(m + " salió de la lista: era su último molde en revisión.");
      else alert(m + " sigue vigilada con: " + r.data.quedan.join(", "));
    },
    async quitar(m) {
      if (!confirm("¿Quitar la máquina " + m + " del monitor?\n\nSe conserva su historia por si hay que volver a vigilarla.")) return;
      await axios.post("/MonitorSenales/Quitar", { maquina: m });
      await this.cargar();
    },
    // Un solo listener para todo lo que se genera con innerHTML: tarjetas,
    // botón cerrar del panel y las × de quitar máquina o liberar molde.
    clic(e) {
      const a = e.target.closest("[data-abre]");
      if (a) { this.abre(+a.dataset.abre); return; }
      const q = e.target.closest("[data-q]");
      if (q) { this.quitar(q.dataset.q); return; }
      const qm = e.target.closest("[data-qm]");
      if (qm) {
        const i = qm.dataset.qm.indexOf("|");
        this.quitaMolde(qm.dataset.qm.slice(0, i), qm.dataset.qm.slice(i + 1));
      }
    },
    abre(i) {
      this.abierta = (this.abierta === i) ? null : i;
      this.pintaDet(this.abierta, false);
    },
    pintaDet(i, silencioso) {
      this.$el.querySelectorAll(".fl").forEach(x => { x.textContent = "▾"; });
      const c = this.$refs.detalle;
      if (i == null || !this._det || !this._det[i]) {
        c.innerHTML = ""; if (!silencioso) this.abierta = null; return;
      }
      const fl = this.$el.querySelector('[data-fl="' + i + '"]');
      if (fl) fl.textContent = "▴";
      const L = this._det[i];
      const n = (this._cnt && this._cnt[i] != null) ? this._cnt[i] : L.length;
      c.innerHTML = '<div class="panel"><div class="ph">' + this._tit[i] +
        ' <span class="mini">(' + n + ")</span>" +
        '<button class="cerrar" data-abre="' + i + '">cerrar</button></div>' +
        (L.length ? L.map(x => x.lastIndexOf("<table", 0) === 0
                          ? x : '<div class="dl">' + x + "</div>").join("")
                  : '<div class="dl mini">Ninguna en este momento.</div>') + "</div>";
    },
    pinta() {
      const D = this.D, R = D.resumen, f = this.f;
      // La planta es la propia instancia: el nombre sale del store, no del backend.
      this.sub = (this.nombreEmpresa || "") + " · " + (D.fuente_txt || "");
      this.$refs.error.innerHTML = D.error ?
        '<div class="err"><strong>Última consulta al servidor falló:</strong> ' + D.error + "</div>" : "";
      // Las anómalas confirmadas —todo renglón en amarillo (fallando ahorita) o
      // naranja (estuvo en amarillo y paró sin aclararse)— viven en la primera
      // tarjeta: se oprime y despliega su tabla, igual que las demás tarjetas.
      const conf = D.filas.filter(r => r.color === "amarillo" || r.color === "naranja");
      const tconf =
        '<table><tr><th class="izq">Máquina</th><th class="izq">Molde</th>' +
        "<th>Estado</th><th>Anorm.<br>10 últ.</th><th>Anorm.<br>24 h</th>" +
        '<th class="izq">Patrón</th><th class="izq">Situación</th></tr>' +
        conf.map(r => {
          const sit = r.color === "amarillo"
            ? "Fallando ahora" + (r.anom_hace_min != null ? " — última anomalía hace " +
              r.anom_hace_min + " min" : "")
            : "Estuvo en amarillo y paró sin aclararse — " +
              (r.sin_señal_min == null ? "sin señal" : r.sin_señal_min < 90 ? r.sin_señal_min +
              " min sin señal" : Math.round(r.sin_señal_min / 60) + " h sin señal") +
              " · pendiente hasta que vuelva a producir";
          return '<tr class="' + (r.color === "amarillo" ? "ojo" : "nar") + '">' +
            '<td class="izq"><strong>' + r.maquina + "</strong></td>" +
            '<td class="izq">' + (r.molde_uso || "—") + "</td>" +
            '<td><span class="clr ' + (r.color === "amarillo" ? "ojo" : "nar") + '">' +
              (r.color === "amarillo" ? "Amarillo" : "Naranja") + "</span></td>" +
            '<td class="cnt' + (r.anom10 ? " mal" : "") + '">' + r.anom10 + "</td>" +
            '<td class="cnt' + (r.anom24 ? " mal" : "") + '">' + r.anom24 + "</td>" +
            '<td class="izq">' + (r.patrones.length ? r.patrones.map(p =>
              '<span class="bad b' + p.clave + '">' + p.texto + "</span>").join(" ")
              : '<span class="mini">—</span>') + "</td>" +
            '<td class="izq"><span class="mini" style="white-space:normal">' + sit +
            "</span></td></tr>";
        }).join("") + "</table>";
      // La pregunta de siempre: ¿a cuál voy ahorita? Es la que está produciendo
      // con su molde sospechoso puesto — la única ventana para confirmar o
      // descartar la falla en piso.
      // Todo el aviso en UN renglón: si ocupa varios, empuja la tabla hacia abajo.
      // Solo entran las que están fallando ahorita; las demás van en letra chica.
      const F = R.enfoco || [], mal = F.filter(x => x.falla), ok = F.filter(x => !x.falla);
      const linea = x => "<strong>" + x.maquina + "</strong> " + x.molde + ' <span class="mini">(' +
        x.anom10 + "/10" + (x.hace != null && x.hace > 0 ? ", hace " + x.hace + " min" : "") +
        (x.patron ? " · " + x.patron : "") + ")</span>";
      let av = "";
      if (mal.length)
        av = '<div class="foco alarma"><b>Ir a ver ahora:</b> ' + mal.map(linea).join(" &nbsp;·&nbsp; ") +
          "</div>";
      if (ok.length) {
        const lim = ok.filter(x => x.limpia), esp = ok.filter(x => !x.limpia);
        let t = [];
        if (lim.length) t.push("<b>limpias, candidatas a salir:</b> " +
          lim.map(x => x.maquina + " (" + x.racha + " ciclos)").join(", "));
        if (esp.length) t.push("<b>sin anomalía reciente pero aún sin racha:</b> " +
          esp.map(x => x.maquina + " (" + x.racha + "/" + x.meta + ")").join(", "));
        av += '<div class="foco ' + (mal.length ? "sec" : "bien") + '">Corriendo su molde en revisión · ' +
           t.join(" &nbsp;·&nbsp; ") + "</div>";
      }
      if (!F.length)
        av = '<div class="foco calma">Ninguna máquina en revisión está corriendo su molde ' +
          "sospechoso en este momento.</div>";
      this.$refs.foco.innerHTML = av;

      // cada tarjeta con detalle se puede oprimir para ver de qué máquinas se trata
      const uno = (f, x) => '<span class="dm">' + f.maquina + "</span> " + x;
      const det = {
        act: D.filas.filter(f => f.activa).map(f => uno(f,
          "última pieza " + (f.ultima || "").slice(0, 16))),
        a24: D.filas.filter(f => f.anom24 > 0).map(f => uno(f,
          f.anom24 + " ciclos anormales · " +
          (f.patrones.map(p => p.texto).join(" · ") || "sin patrón"))),
        a10: D.filas.filter(f => f.anom10 > 0).map(f => uno(f,
          f.anom10 + " de sus 10 últimos · " +
          (f.patrones.map(p => p.texto).join(" · ") || "sin patrón"))),
        vig: D.filas.map(f => uno(f, f.motivo))};
      this.$refs.cards.innerHTML = [
        ["Anómalas confirmadas", f(conf.length), conf.length ? "al" : "ok", null],
        ["Máquinas vigiladas", f(R.vigiladas), "", det.vig],
        ["Activas ahora", R.activas + '<span class="de">/' + R.vigiladas + "</span>",
          R.activas ? "ok" : "", det.act],
        ["Con anomalía (24 h)", f(R.con_anomalia), R.con_anomalia ? "al" : "", det.a24],
        ["Ciclos anormales 24 h", f(R.anom24), R.anom24 ? "al" : "", det.a24],
        ["Anormales en los 10 últimos", f(R.anom10), R.anom10 ? "al" : "", det.a10]
      // siempre clicable, aunque la lista esté vacía: una tarjeta que no responde
      // se lee como si estuviera rota
      ].map(([t, n, c], i) => '<div class="card ' + c + ' clic" data-abre="' + i + '"' +
        ' title="Oprime para ver cuáles"><div class="n">' + n + '</div><div class="t">' + t +
        ' <span class="fl" data-fl="' + i + '">▾</span></div></div>').join("");
      // la tarjeta 0 despliega una TABLA completa, no la lista de renglones; por
      // eso lleva su cuenta aparte en _cnt (la tabla es un solo elemento del arreglo)
      this._det = [conf.length ? [tconf] : [], det.vig, det.act, det.a24, det.a24, det.a10];
      this._cnt = {0: conf.length};
      this._tit = ["Anómalas confirmadas — en amarillo o naranja", "Máquinas vigiladas",
        "Produciendo en este momento", "Con anomalía en las últimas 24 h",
        "Con anomalía en las últimas 24 h", "Con anormales entre los 10 últimos"];
      if (this.abierta != null) this.pintaDet(this.abierta, true);

      let cab = '<th class="izq">Máquina y molde</th><th>Estado</th>';
      for (let i = 1; i <= 10; i++) cab += "<th>" + i + "</th>";
      cab += "<th>Anorm.<br>10 últ.</th><th>Anorm.<br>24 h</th>" +
           '<th class="izq">Patrón detectado</th><th></th>';
      this.$refs.cab.innerHTML = cab;

      this.$refs.cuerpo.innerHTML = D.filas.map(r => {
        const c = r.ciclos, hueco = 10 - c.length;
        let celdas = "";
        for (let i = 0; i < hueco; i++) celdas += '<td class="c vac">·</td>';
        const POR = {pulso: "pulso por debajo de " + D.pulso_max + " s, no corresponde a un golpe",
                   modo: "cae fuera del modo largo: es la otra mediana",
                   desv: "más de " + D.sigmas + " σ por debajo de la mediana"};
        c.forEach(x => {
          const cls = x.anormal ? (x.razones.indexOf("pulso") >= 0 ? "an" : "an2") : (x.paro ? "pa" : "");
          const txt = x.paro ? (x.tc >= 3600 ? (x.tc / 3600).toFixed(1) + " h" : (x.tc / 60).toFixed(0) + " m")
                          : x.tc.toFixed(1);
          celdas += '<td class="c ' + cls + '" title="' + x.hora +
            (x.inc > 1 ? " · " + x.inc + " golpes en el tramo" : "") +
            (x.paro ? " · tramo largo, se toma como paro" : "") +
            (x.razones || []).map(z => " · " + POR[z]).join("") + '">' + txt + "</td>";
        });
        const est = r.activa ? '<span class="pill on">Activa</span>'
          : '<span class="pill off">' + (r.sin_señal_min == null ? "Sin datos"
            : r.sin_señal_min < 90 ? "hace " + r.sin_señal_min + " min"
            : r.sin_señal_min < 2880 ? "hace " + Math.round(r.sin_señal_min / 60) + " h"
            : "hace " + Math.round(r.sin_señal_min / 1440) + " d") + "</span>";
        const ult = r.ultima ? r.ultima.slice(0, 5) + " " + r.ultima.slice(11, 19) : "sin lecturas";
        const fx = r.molde_fecha ? r.molde_fecha.slice(8, 10) + "/" + r.molde_fecha.slice(5, 7) : "";
        const rec = (r.plan || []).find(x => x.molde === r.molde_uso);
        const std = (rec && rec.std) ? rec.std : r.std;
        const molde = '<span class="' + (r.molde_firme ? "" : "sug") + '">' + (r.molde_uso || "—") +
          "</span>" + (std ? ' <span class="std">' + (+std) + " s</span>" : "") +
          (r.en_revision ? ' <span class="rev">●</span>' : "");
        const sig = (r.plan || []).slice(1).map(x => x.revision ?
          '<span class="rev">' + x.molde + "</span>" : x.molde).join(", ");
        // La procedencia del molde va pegada al nombre, no en su propio renglón:
        // es un dato corto y con el ancho de la columna cabe de sobra.
        const proc = '<span class="mini proc">' + r.molde_origen + (fx ? " · " + fx : "") +
          (sig ? " · luego " + sig : "") + "</span>";

        // El aviso de qué molde le toca y los moldes en revisión comparten renglón:
        // los dos son cortos y juntos ahorran una línea por máquina.
        const rev = 'rev: ' + ((r.moldes || "").split(",").map(x => x.trim())
          .filter(Boolean).map(x => '<span class="chip' + (x === r.molde_uso ? " act" : "") +
          '">' + x + '<button class="xm" title="Liberar ' + r.maquina + " con el molde " + x +
          '" data-qm="' + r.maquina + "|" + x + '">×</button></span>').join(" ") || "—");

        const pie = '<div class="pie">' +
          '<span class="esp e' + r.espera.clave + '" title="' + r.espera.detalle + '">' +
          r.espera.texto + "</span>" +
          '<span class="mini">' + rev + "</span>" +
          // para agendar la inspección: solo tiene sentido si no está corriendo ya
          (r.espera.cuando && !r.activa
            ? '<span class="cita">' + r.espera.cuando + "</span>" : "") + "</div>";
        // amarillo = está fallando ahora; naranja = estuvo en amarillo, se fue sin
        // aclararse y su corrida tuvo volumen; blanco = ya corrió limpia.
        // máquina y molde en una sola columna, para no gastar ancho de más
        const CLR = {amarillo: "ojo", naranja: "nar"};
        const pq = r.color === "amarillo"
          ? "Está corriendo su molde sospechoso y falló hace " + r.anom_hace_min + " min."
          : r.color === "naranja"
          ? "Estuvo en amarillo y paró sin aclararse: " +
            (r.sin_señal_min < 90 ? r.sin_señal_min + " min" : Math.round(r.sin_señal_min / 60) + " h") +
            " sin señal. Parada se queda naranja; al producir regresa a amarillo, y solo " +
            "sale de la tabla liberándose con su molde sospechoso."
          : "Sin marca: no está fallando en este momento.";
        return '<tr class="' + (CLR[r.color] || "") + '" title="' + pq + '">' +
          '<td class="izq" title="' + (r.plan_ots ? "OT " + r.plan_ots :
            "Sin orden asignada en el plan") + ". No existe registro del molde montado" +
            ' físicamente; este es el mejor dato disponible.">' +
            '<div class="maq">' + r.maquina + ' <span class="sep">·</span> ' + molde +
              " " + proc + "</div>" +
            '<div class="mini" title="' + r.motivo + '">' + r.motivo + "</div>" +
            (r.nota ? '<div class="nota-piso">' + r.nota + "</div>" : "") +
            // cada molde en revisión trae su propia ×: se libera la COMBINACIÓN
            // máquina–molde. Si a la máquina le quedan otros moldes, sigue vigilada.
            pie + "</td>" +
          "<td>" + est + '<div class="mini">' + ult + "</div></td>" +
          celdas +
          '<td class="cnt' + (r.anom10 ? " mal" : "") + '">' + r.anom10 +
            (r.racha ? '<div class="mini" title="ciclos seguidos sin una anomalía">racha ' +
              r.racha + "</div>" : "") + "</td>" +
          '<td class="cnt' + (r.anom24 ? " mal" : "") + '">' + r.anom24 + "</td>" +
          '<td class="izq">' + (r.patrones.length ?
            r.patrones.map(p => '<span class="bad b' + p.clave + '">' + p.texto + "</span>").join(" ")
            : '<span class="mini">ninguno de los tres</span>') +
            '<div class="mini">mediana ' + (r.mediana == null ? "—" : r.mediana + " s ± " + r.desv +
            (r.umbral != null ? " · anormal &lt; " + r.umbral + " s" : "")) + "</div>" +
            (r.prom_ok != null ? '<div class="mini prom" title="promedio de los ciclos que no ' +
              'salieron anormales: el ritmo real cuando la señal se porta bien">promedio ' +
              "sin anormales <b>" + r.prom_ok + " s</b> (" + r.n_ok + " ciclos)</div>" : "") +
            "</td>" +
          '<td><button class="x" title="Quitar del monitor" data-q="' +
            r.maquina + '">×</button></td></tr>';
      }).join("") || '<tr><td colspan="17" class="mini" style="padding:22px">' +
        "No hay máquinas vigiladas. Agrega una abajo.</td></tr>";

      // el refresco automático no debe borrar lo que el usuario está capturando:
      // el select es de Vue (v-model), aquí solo se actualiza la lista
      this.disponibles = D.disponibles;
      if (this.disponibles.indexOf(this.nueva) < 0) this.nueva = "";

      const C = D.cobertura, EST = {limpia: ["ok", "sin patrón"], anomala: ["mal", "anómala → dada de alta"],
        leve: ["pend", "caída leve, no amerita alta"],
        pendiente: ["pend", "juntando ciclos"], "sin muestra": ["pend", "sin muestra suficiente"]};
      // la leyenda dice exactamente lo que se validó y lo que no: una máquina sin
      // ciclos suficientes NO quedó validada, y hay que decirlo
      const sinM = D.sesiones.filter(s => s.estado === "sin muestra").map(s => s.maquina);
      let leyenda;
      if (C.total === 0)
        leyenda = '<span class="mini">Todavía no se ha detectado ninguna orden en progreso.</span>';
      else if (C.pendientes)
        leyenda = '<span class="pend-leyenda">Faltan ' + C.pendientes + " por dictaminar: aún no " +
          "juntan los " + D.ciclos_val + " ciclos que se necesitan.</span>";
      else if (sinM.length)
        leyenda = '<span class="ok-leyenda">✓ Validadas todas las máquinas que arrancaron orden ' +
          "y produjeron lo suficiente, incluidas las que estuvieron activas con la app apagada." +
          '</span> <span class="pend-leyenda">' + (sinM.length === 1
            ? "Queda fuera una que no llegó a " : "Quedan fuera " + sinM.length + " que no llegaron a ") +
          D.ciclos_val + " ciclos y no se pudo" + (sinM.length === 1 ? "" : "ieron") + " dictaminar: " +
          sinM.join(", ") + ".</span>";
      else
        leyenda = '<span class="ok-leyenda">✓ Todas las máquinas que arrancaron una orden —' +
          "incluidas las que estuvieron activas con la app apagada— están validadas.</span>";
      this.$refs.cajaSesiones.innerHTML =
        '<div style="margin-bottom:8px"><strong style="font-size:13px">Validación al arrancar orden</strong>' +
        ' <span class="mini">· cada vez que ops pone una orden en progreso, esa máquina se dictamina ' +
        "una vez con los primeros ciclos, esté o no en la lista; si cae en cualquiera de las tres " +
        "reglas se agrega sola</span></div>" +
        '<div style="margin-bottom:10px">' + leyenda + ' <span class="mini">' + C.total + " órdenes: " +
        C.limpias + " sin patrón · " + C.anomalas + " anómalas · " + C.leves + " con caída leve · " +
        C.pendientes + " por dictaminar · " + C.sin_muestra + " sin muestra</span></div>" +
        (D.sesiones.length ? '<table style="font-size:12px"><tr><th class="izq">Máquina</th>' +
          '<th class="izq">Orden</th><th class="izq">Arrancó</th><th>Ciclos</th>' +
          '<th class="izq">Dictamen</th></tr>' +
          D.sesiones.map(s => '<tr><td class="izq"><strong>' + s.maquina + "</strong></td>" +
          '<td class="izq">' + s.ot + '</td><td class="izq">' + s.inicio + "</td>" +
          "<td>" + (s.ciclos || "—") + '</td><td class="izq"><span class="est ' +
          (EST[s.estado] || ["pend", s.estado])[0] + '">' + (EST[s.estado] || ["", s.estado])[1] + "</span> " +
          '<span class="mini">' + (s.patrones || "") + "</span></td></tr>").join("") + "</table>" : "");

      this.$refs.cajaAvisos.innerHTML =
        '<div style="margin-bottom:8px"><strong style="font-size:13px">Avisos registrados</strong>' +
        ' <span class="mini">· uno por máquina que arranque y empiece a fallar, y luego ' +
        D.espera_min + " min de silencio de esa máquina para no repetir lo ya avisado" +
        "</span></div>" +
        (D.avisos.length ? '<table style="font-size:12px">' + D.avisos.map(a =>
          '<tr><td class="izq" style="white-space:nowrap;width:90px">' + a.cuando + "</td>" +
          '<td class="izq" style="width:90px"><strong>' + a.maquina + "</strong></td>" +
          '<td class="izq">' + (a.texto || "") + "</td></tr>").join("") + "</table>"
          : '<div class="mini">Todavía no hay avisos.</div>');

      this.$refs.nota.innerHTML =
        "<strong>Cómo leer la tabla.</strong> Las 10 columnas son los tiempos entre ciclo y ciclo, " +
        "en segundos, del más viejo al más reciente (la 10 es el último). El tiempo se calcula " +
        "dividiendo los segundos transcurridos entre el avance del contador, de modo que una lectura " +
        "que se pierde en el camino no ensucia la medición. En gris y cursiva, los tramos de más de " +
        "10 minutos, que se toman como paro.<br>" +
        "<strong>El color del renglón.</strong> " +
        '<span class="clr ojo">Amarillo</span> está corriendo su molde sospechoso y falló hace menos ' +
        "de " + D.resumen.foco_min + " minutos: es el momento de ir a verla, y por eso van hasta arriba. " +
        '<span class="clr nar">Naranja</span> estuvo en amarillo y paró sin aclararse —más de ' +
        D.horas_naranja + " h sin señal—; parada se queda naranja el tiempo que sea, no caduca. " +
        "En cuanto vuelva a producir regresa a amarillo. " +
        '<span class="clr bla">Blanco</span> corre bien con OTRO molde (' + D.ciclos_blanco + " disparos " +
        "sin evidencia de anomalía). Aun en blanco sigue en la tabla: de la tabla solo se sale " +
        "liberándose, corriendo limpia con el molde por el que se le declaró sospechosa.<br>" +
        "<strong>Los tres patrones que marcan anomalía.</strong> Basta con que se cumpla uno. " +
        '<span class="bad bmodo">Dos medianas</span> la serie se parte en grupos separados y la ' +
        "máquina alterna entre ellos, como 12 y 18 s; se marcan los ciclos del grupo corto, porque " +
        "un pulso de más acorta el intervalo, nunca lo alarga. " +
        '<span class="bad bpulso">Pulso ajeno</span> ciclos por debajo de ' + D.pulso_max + " s, que no " +
        "corresponden a un golpe de molde. " +
        '<span class="bad bdesv">Caídas de más de ' + D.sigmas + " σ</span> ciclos que se hunden más de " +
        D.sigmas + " desviaciones por debajo de la mediana; este solo se aplica cuando la serie es de " +
        "una sola mediana, porque si hay dos la mediana ya viene contaminada por la propia falla. " +
        "Nada de lo que queda <em>por arriba</em> de la mediana se marca: pudo ser paro.<br>" +
        "<strong>La columna de molde.</strong> No existe en la base un registro de qué molde está " +
        "montado físicamente, así que se toma el mejor dato disponible, en este orden: el molde de " +
        "la <em>orden abierta</em>; si no hay orden abierta, el que el programa de producción tiene " +
        "asignado a la máquina; y si tampoco, el último que reportó producción. En cursiva cuando es " +
        "sugerido y no confirmado por una orden. El punto rojo <span class=\"rev\">●</span> marca que " +
        "el molde puesto es justamente uno de los que están en revisión: ahí la falla se va a presentar sola.<br>" +
        "<strong>Actualización.</strong> La aplicación consulta al servidor cada " +
        (D.refresco_seg / 60) + " minutos, en modo solo lectura. Última consulta: " +
        (D.consulta_hace_seg == null ? "—" : "hace " +
          (D.consulta_hace_seg < 90 ? D.consulta_hace_seg + " s" : Math.round(D.consulta_hace_seg / 60) + " min")) +
        ". La planta sincroniza un paquete por minuto.";
      this.ultimo = Date.now(); this.tic();
    },
    tic() {
      if (!this.D) return;
      const seg = (this.D.consulta_hace_seg || 0) + Math.round((Date.now() - this.ultimo) / 1000);
      const falta = Math.max(0, this.D.refresco_seg - seg);
      this.reloj = "próxima consulta en " + Math.floor(falta / 60) + ":" + String(falta % 60).padStart(2, "0");
    },
  },
};
</script>

<style>
/* Réplica del CSS del tablero, todo bajo #monitor-senales para no tocar al
   resto de la plataforma. No es "scoped" a propósito: casi todo el contenido
   se genera con innerHTML y el scoping de Vue no lo alcanzaría. */
#monitor-senales{--teal:#197F72;--teald:#0D564F;--rojo:#C00000;--ambar:#BF8F00;
 --azul:#2E74B5;
 --fondo:#f4f6f6;--tarjeta:#fff;--texto:#1c2321;--suave:#6b7a77;--linea:#dfe5e4;}
@media(prefers-color-scheme:dark){#monitor-senales{--fondo:#111615;--tarjeta:#1a2120;
 --texto:#e8edec;--suave:#8fa19d;--linea:#2b3634;}}
#monitor-senales{margin:0;background:var(--fondo);color:var(--texto);
 font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif;
 border-radius:8px;overflow:hidden}
#monitor-senales *{box-sizing:border-box}
#monitor-senales .ms-head{background:var(--teal);color:#fff;padding:14px 20px;display:flex;
 align-items:center;gap:16px;flex-wrap:wrap}
#monitor-senales .ms-head h1{margin:0;font-size:17px;font-weight:600;letter-spacing:.2px}
#monitor-senales .ms-head .sub{font-size:12px;opacity:.85}
#monitor-senales .ms-head .der{margin-left:auto;display:flex;align-items:center;gap:10px;font-size:12px}
#monitor-senales button{font:inherit;border:0;border-radius:6px;padding:6px 12px;cursor:pointer;
 background:var(--teald);color:#fff}
#monitor-senales button.claro{background:rgba(255,255,255,.18)}
#monitor-senales button:hover{filter:brightness(1.12)}
#monitor-senales main{padding:18px 20px 40px;max-width:1600px;margin:0 auto;display:block}
#monitor-senales .cards{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));
 gap:12px;margin-bottom:18px}
#monitor-senales .card{background:var(--tarjeta);border:1px solid var(--linea);border-radius:10px;
 padding:12px 14px}
#monitor-senales .card .n{font-size:26px;font-weight:600;line-height:1.1}
#monitor-senales .card .de{font-size:17px;font-weight:500;color:var(--suave)}
#monitor-senales .card .t{font-size:11px;color:var(--suave);text-transform:uppercase;
 letter-spacing:.6px;margin-top:2px}
#monitor-senales .card.al .n{color:var(--rojo)}
#monitor-senales .card.ok .n{color:var(--teal)}
#monitor-senales .card.clic{cursor:pointer;transition:border-color .12s}
#monitor-senales .card.clic:hover{border-color:var(--teal)}
#monitor-senales .fl{font-size:10px;opacity:.55}
#monitor-senales .panel{background:var(--tarjeta);border:1px solid var(--teal);border-radius:10px;
 padding:10px 14px 12px;margin:-4px 0 18px}
#monitor-senales .ph{font-size:12px;font-weight:600;color:var(--teal);text-transform:uppercase;
 letter-spacing:.5px;margin-bottom:7px;display:flex;align-items:center;gap:8px}
#monitor-senales .ph .mini{text-transform:none;letter-spacing:0;font-weight:400}
#monitor-senales .cerrar{margin-left:auto;background:transparent;color:var(--suave);font-size:11px;
 padding:2px 8px;text-transform:none;letter-spacing:0}
#monitor-senales .cerrar:hover{color:var(--rojo);background:rgba(192,0,0,.08)}
#monitor-senales .dl{font-size:12.5px;padding:3px 0;border-top:1px solid var(--linea)}
#monitor-senales .dm{font-weight:700;display:inline-block;min-width:52px}
#monitor-senales .tabla{background:var(--tarjeta);border:1px solid var(--linea);border-radius:10px;
 overflow-x:auto}
#monitor-senales table{border-collapse:collapse;width:100%;font-size:12.5px}
#monitor-senales th,#monitor-senales td{padding:6px 6px;text-align:center;
 border-bottom:1px solid var(--linea);white-space:nowrap}
#monitor-senales th{background:var(--teal);color:#fff;font-weight:600;font-size:10.5px;
 text-transform:uppercase;letter-spacing:.3px}
#monitor-senales th.izq,#monitor-senales td.izq{text-align:left}
#monitor-senales tbody tr:hover{background:rgba(25,127,114,.06)}
#monitor-senales tbody tr.ojo,#monitor-senales tr.ojo{background:rgba(255,206,0,.26)}
#monitor-senales tbody tr.ojo:hover{background:rgba(255,206,0,.34)}
#monitor-senales tbody tr.ojo td,#monitor-senales tr.ojo td{border-bottom-color:rgba(191,143,0,.35)}
#monitor-senales tbody tr.nar,#monitor-senales tr.nar{background:rgba(232,120,24,.22)}
#monitor-senales tbody tr.nar:hover{background:rgba(232,120,24,.30)}
#monitor-senales tbody tr.nar td,#monitor-senales tr.nar td{border-bottom-color:rgba(232,120,24,.38)}
@media(prefers-color-scheme:dark){
 #monitor-senales tbody tr.ojo,#monitor-senales tr.ojo{background:rgba(255,206,0,.13)}
 #monitor-senales tbody tr.ojo:hover{background:rgba(255,206,0,.19)}
 #monitor-senales tbody tr.nar,#monitor-senales tr.nar{background:rgba(232,120,24,.16)}
 #monitor-senales tbody tr.nar:hover{background:rgba(232,120,24,.24)}}
#monitor-senales .maq{font-weight:600;font-size:14px}
#monitor-senales .maq .sep{color:var(--suave);font-weight:400;margin:0 1px}
#monitor-senales .std{font-size:11px;font-weight:600;color:var(--azul);background:rgba(46,116,181,.12);
 padding:1px 6px;border-radius:5px;vertical-align:middle}
/* La primera columna concentra máquina, molde, motivo, nota de piso y los
   moldes en revisión: se le da ancho propio para que no se apriete. */
#monitor-senales .tabla th:first-child,
#monitor-senales .tabla td:first-child{min-width:380px}
#monitor-senales td.izq .mini{max-width:380px}
#monitor-senales .mini{font-size:11px;color:var(--suave)}
#monitor-senales .pill{display:inline-block;padding:2px 9px;border-radius:20px;font-size:11px;
 font-weight:600}
#monitor-senales .on{background:rgba(25,127,114,.16);color:var(--teal)}
#monitor-senales .off{background:rgba(0,0,0,.07);color:var(--suave)}
@media(prefers-color-scheme:dark){#monitor-senales .off{background:rgba(255,255,255,.08)}}
#monitor-senales td.c{font-variant-numeric:tabular-nums;min-width:46px}
#monitor-senales td.izq .mini{max-width:380px;overflow:hidden;text-overflow:ellipsis}
#monitor-senales td.c.an{background:rgba(192,0,0,.14);color:var(--rojo);font-weight:700}
#monitor-senales td.c.an2{background:rgba(191,143,0,.20);color:var(--ambar);font-weight:700}
#monitor-senales .bad{display:inline-block;padding:2px 8px;border-radius:5px;font-size:10.5px;
 font-weight:600;margin:1px 2px 1px 0;white-space:nowrap}
#monitor-senales .bmodo{background:rgba(191,143,0,.20);color:var(--ambar)}
#monitor-senales .bpulso{background:rgba(192,0,0,.15);color:var(--rojo)}
#monitor-senales .bdesv{background:rgba(46,116,181,.16);color:var(--azul)}
#monitor-senales .est{display:inline-block;padding:1px 8px;border-radius:5px;font-size:10.5px;
 font-weight:600}
#monitor-senales .est.ok{background:rgba(25,127,114,.16);color:var(--teal)}
#monitor-senales .est.mal{background:rgba(192,0,0,.15);color:var(--rojo)}
#monitor-senales .est.pend{background:rgba(191,143,0,.18);color:var(--ambar)}
#monitor-senales .foco{border-radius:10px;padding:13px 16px;margin-bottom:14px;font-size:14px;
 line-height:1.5;border:1px solid var(--linea)}
#monitor-senales .foco .mini{display:inline}
#monitor-senales .foco.alarma{background:rgba(192,0,0,.10);border-color:rgba(192,0,0,.45);
 color:var(--texto)}
#monitor-senales .foco.alarma strong{color:var(--rojo)}
#monitor-senales .foco.bien{background:rgba(25,127,114,.10);border-color:rgba(25,127,114,.4)}
#monitor-senales .foco.bien strong{color:var(--teal)}
#monitor-senales .foco.espera{background:rgba(191,143,0,.10);border-color:rgba(191,143,0,.45)}
#monitor-senales .foco.espera strong{color:var(--ambar)}
#monitor-senales .foco.calma{background:var(--tarjeta);color:var(--suave);font-size:13px}
#monitor-senales .cita{font-size:10.5px;color:var(--azul);font-weight:600}
#monitor-senales .prom{color:var(--teal)}
#monitor-senales .prom b{color:var(--teal)}
#monitor-senales .nota-piso{font-size:11px;line-height:1.4;margin:4px 0;padding:6px 9px;
 border-left:3px solid var(--rojo);background:rgba(192,0,0,.07);border-radius:0 5px 5px 0;
 max-width:380px;white-space:normal}
#monitor-senales .chip{display:inline-block;padding:0 2px 0 6px;border-radius:5px;font-size:10.5px;
 background:rgba(0,0,0,.06);margin:1px 3px 1px 0;white-space:nowrap}
@media(prefers-color-scheme:dark){#monitor-senales .chip{background:rgba(255,255,255,.09)}}
#monitor-senales .chip.act{background:rgba(192,0,0,.14);color:var(--rojo);font-weight:700}
#monitor-senales .xm{background:transparent;color:var(--suave);padding:0 4px;font-size:12px;
 line-height:1;border-radius:4px}
#monitor-senales .xm:hover{color:var(--rojo);background:rgba(192,0,0,.12)}
#monitor-senales .foco.sec{background:var(--tarjeta);font-size:12.5px;padding:8px 14px;
 margin-top:-8px}
/* Procedencia del molde pegada al nombre, y pie de renglón con el aviso de molde
   y los moldes en revisión lado a lado: dos líneas menos por máquina. */
#monitor-senales .proc{font-weight:400;margin-left:2px}
#monitor-senales .pie{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:3px}
#monitor-senales .esp{font-size:10.5px;font-weight:600;display:inline-block;
 padding:1px 7px;border-radius:5px;white-space:normal;max-width:230px;cursor:help}
#monitor-senales .erepite{background:rgba(192,0,0,.13);color:var(--rojo)}
#monitor-senales .eluego{background:rgba(191,143,0,.18);color:var(--ambar)}
#monitor-senales .eotro{background:rgba(25,127,114,.14);color:var(--teal)}
#monitor-senales .esinref{background:rgba(0,0,0,.07);color:var(--suave)}
@media(prefers-color-scheme:dark){#monitor-senales .esinref{background:rgba(255,255,255,.08)}}
#monitor-senales .clr{display:inline-block;padding:1px 8px;border-radius:5px;font-size:11px;
 font-weight:700;border:1px solid var(--linea)}
#monitor-senales .clr.ojo{background:rgba(255,206,0,.30)}
#monitor-senales .clr.nar{background:rgba(232,120,24,.26)}
#monitor-senales .clr.bla{background:transparent}
#monitor-senales .ok-leyenda{color:var(--teal);font-weight:600;font-size:13px}
#monitor-senales .pend-leyenda{color:var(--ambar);font-weight:600;font-size:13px}
#monitor-senales td.c.pa{color:var(--suave);font-style:italic}
#monitor-senales td.c.vac{color:var(--linea)}
#monitor-senales .cnt{font-weight:700}
#monitor-senales .cnt.mal{color:var(--rojo)}
#monitor-senales .x{background:transparent;color:var(--suave);padding:2px 7px;font-size:15px;
 line-height:1}
#monitor-senales .x:hover{color:var(--rojo);background:rgba(192,0,0,.1)}
#monitor-senales .barra{display:flex;gap:8px;align-items:center;margin:16px 0 0;flex-wrap:wrap;
 background:var(--tarjeta);border:1px solid var(--linea);border-radius:10px;
 padding:12px 14px}
#monitor-senales select,#monitor-senales input{font:inherit;padding:6px 9px;
 border:1px solid var(--linea);border-radius:6px;background:var(--fondo);color:var(--texto)}
#monitor-senales .nota{font-size:12px;color:var(--suave);margin-top:14px;line-height:1.6}
#monitor-senales .err{background:rgba(192,0,0,.12);color:var(--rojo);padding:9px 12px;
 border-radius:8px;margin-bottom:14px;font-size:13px}
#monitor-senales .rev{color:var(--rojo);font-weight:600}
#monitor-senales .sug{font-style:italic;color:var(--ambar)}
</style>
